import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		local: 'San Diego/Tijuana',
    campaigns: [
    {
      id: 2,
      title: 'Black Womxn Deserve Fund',
      description: 'A mutual aid relief fund centering Black womxn and/or femme folks',
      organizers: [{id: 1, name: 'March for Black Womxn San Diego', url: 'https://www.m4bwsd.com/'}],
      donateMethods: [
      {type: 'Venmo', url: 'https://venmo.com/kelseliv'},
      {type: 'Cash App', url: 'https://cash.app/$KelseLiv'},
      {type: 'PayPal', url: 'https://www.paypal.me/kelseliv'}
      ]
    },
    {
      id: 1,
      title: 'Navajo Nation Medical Supply Drive',
      description: 'A nonprofit drive to supply urgently-needed PPE to frontline medical staff of the Navajo Nation',
      organizers: [{id: 1, name: 'AIM SoCal', url: 'https://aimsocal.org/index.html'}],
      donateMethods: [
      {type: 'Venmo', url: 'https://venmo.com/AmericanIndian-MovementSoCal'}
      ]
    },
    //{
    //  id: 3,
    //  title: 'DeDe McClure Community Bail Fund',
    //  description: 'A grassroots community bail fund inspired by National Bail Out #FreeBlackMamas',
    //  organizers: [{id: 1, name: 'grassroots organizers'},{id: 2, name: 'housed at Peace Resource Center of San Diego'}],
    //  donateMethods: [
    //  {type: 'PayPal', url: 'https://www.prcsd.org/bail-mothers-out-of-jail-this-mothers-day/'}
    //  ]
    //},
    {
      id: 4,
      title: 'Undocuqueer Relief Fund',
      description: 'A mutual aid relief fund organized by undocumented LGBTQ+ POC',
      organizers: [{id: 1, name: 'Undocuqueer', url: 'https://www.undocuqueer.org/'}],
      donateMethods: [
      {type: 'Venmo', url: 'https://venmo.com/beto-soto-1'}
      ]
    },
    {
      id: 5,
      title: 'LGBTQI+ Tijuana Shelter Drive',
      description: 'A nonprofit LGBTQI+ migrants and asylum seekers in Mexico',
      organizers: [{id: 1, name: 'Casa Arcoiris', url: 'https://www.facebook.com/CasaArcoirisAC/'}],
      donateMethods: [
      {type: 'GoFundMe', url: 'https://www.gofundme.com/f/casaarcoiris'}
      ]
    },
    //{
    //  id: 6,
    //  title: 'Tijuana Migrant Community Relief Fund',
    //  description: 'Support for black migrants and asylum seekers in Tijuana during COVID-19',
    //  organizers: [{id: 1, name: 'Espacio Migrante', url: 'https://www.espaciomigrante.org/'}],
    //  donateMethods: [
    //  {type: 'GoFundMe', url: 'https://charity.gofundme.com/tijuana-migrant-community-relief-fund'},
    //  ]
    //},
    {
      id: 7,
      title: 'Hotel Vouchers 4 All',
      description: 'A grassroots effort supporting unhoused community members with hotel rooms',
      organizers: [{id: 1, name: 'Tasha Williamson'},{id: 2, name: 'Amie Zamudio'}],
      donateMethods: [
      {type: 'GoFundMe', url: 'https://www.gofundme.com/f/hotelvouchers4all'},
      {type: 'Fundly', url: 'https://fundly.com/hotel-vouchers-4-all'}
      ]
    },
    {
      id: 9,
      title: 'El Comedor Tijuana Kitchen Emergency Fund',
      description: 'An all-volunteer community mutual aid kitchen now serving as a frontline crisis preparedness center in Tijuana',
      organizers: [{id: 1, name: 'Enzo D\'Angelo'},{id: 2, name: 'Contra Viento Y Marea', url: 'http://contravientoymareatj.com/'}],
      donateMethods: [
      {type: 'GoFundMe', url: 'https://www.gofundme.com/f/tijuana-kitchen'}
      ]
    }
    ]
  }
});

export default app;
